<div class="tabset">
  <div [ngClass]="{ 'tabs is-toggle': true, transparent }">
    <ul>
      <li
        [ngClass]="{ 'is-active': selectedTab === tab.id }"
        *ngFor="let tab of tabs"
      >
        <a (click)="tabChange.emit(tab.id)">
          <span [translationEditableDirective]="tab.name">
            {{ tab.name | translate }}</span
          >
        </a>
      </li>
    </ul>
  </div>

  <div [ngClass]="{ 'tab-content': true, transparent }">
    <ng-content></ng-content>
  </div>
</div>
